module.exports = require("./main.js");


//////////////////
// WEBPACK FOOTER
// ./~/csvtojson/libs/interfaces/cli/index.js
// module id = 816
// module chunks = 0